import {Line, LineConfig} from '@ant-design/charts'
import {Chart} from '@antv/g2/lib'
import {Meta} from '@antv/g2plot'

import {ChartDataProps, DailyChartData} from '../../../model/chart'
import {dailyGarminStepTheme} from '../theme/daily_garmin_step_theme'
import {ChartCard} from '../template/chart_card'
import {defaultDailyChartXAxisConfig} from '../../../lib/chart_data/util/formatter'
import {useEffect, useMemo, useState} from 'react'

export const GarminDailySummarySleepSkinTemperatureDeviationChart = (props: ChartDataProps<DailyChartData>) => {
  const {height, width, title, data} = props
  const [chartInstance, setChartInstance] = useState<Chart | undefined>()
  const xField: keyof DailyChartData = 'yymmdd'
  const yField: keyof DailyChartData = 'value'
  const meta: {[key in keyof DailyChartData]: Meta} = {
    yymmdd: {
      alias: 'Date',
    },
    value: {
      alias: 'Deviation Avg.',
    },
  }
  const yAxisConfig = {
    title: {text: 'Deviation Avg'},
  }

  useEffect(() => {
    if (chartInstance) {
      chartInstance.scale('value', {
        min: -1.5,
        max: 1.5,
        // nice: true //auto scale
      })
    }
  }, [chartInstance])

  useEffect(() => {
    if (chartInstance) {
      chartInstance.changeData(data)
    }
  }, [chartInstance, data])

  const lineConfig: LineConfig = {
    data: [],
    autoFit: true,
    xField,
    yField,
    xAxis: defaultDailyChartXAxisConfig,
    yAxis: yAxisConfig,
    meta,
    theme: dailyGarminStepTheme,
    onReady: (chart) => {
      setChartInstance(chart.chart)
    },
  }

  const config = useMemo<LineConfig>(() => {
    return lineConfig
  }, [])

  const chartCardProps = {
    height: height,
    width: width,
    chartTitle: title ?? 'Garmin Connect skin temperature deviation Avg. during sleep',
    hintDescription: '',
    chart: <Line {...config} />,
  }
  return <ChartCard {...chartCardProps} />
}
